





import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'CloseButton',
  emits: ['close'],
  props: {
    ariaLabel: {
      type: String,
      required: false,
      default: () => 'Close',
    },
  },
})
